import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../utl/models/Message";
import { ClientsState } from "../models/ClientsState";

const setMessageClients = (state: ClientsState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessageClients;